import React from "react";
import { affordances } from "../../../util/analytics";
import { PUBTYPE } from "../../../constants/pubType";
import InlineMedia from "../../InlineMedia";
import AlgorithmBlock from "../../AlgorithmBlock";
import InlineImage from "../../InlineImage";
import InlineContextImage from "../../InlineContextImage";

const DATA_TRANSFORM = {
  INLINE_IMAGE_IN_CONTEXT: "inline-image-in-context",
};

const makeMediaMap = (mediaItems) =>
  mediaItems.reduce((acc, item, index) => {
    acc[item.publicId] = item;
    acc[item.publicId].index = index;
    return acc;
  }, {});

export default function useInlineImageProcessor({
  handleOpenPDF,
  handleOpenLightBoxImage,
  images,
  algorithms,
  pubType,
}) {
  const imagesMap = makeMediaMap(images);
  const algorithmsMap = makeMediaMap(algorithms);

  const processInlineImage = (node) => {
    const title = node.attribs["data-title"];
    const publicId = node.attribs["data-public-id"];
    const copyright = node.attribs["data-copyright"];
    const description = node.attribs["data-description"];
    const isMediaClickDisabled =
      node.attribs["data-type"] === "disable-media-click";

    const image = imagesMap[publicId];
    const algorithm = algorithmsMap[publicId];

    if (image && pubType === PUBTYPE.PATIENT_HANDOUTS) {
      return image.dataTransform === DATA_TRANSFORM.INLINE_IMAGE_IN_CONTEXT ? (
        <InlineContextImage title={title} publicId={publicId} />
      ) : (
        <InlineImage title={title} copyright={copyright} publicId={publicId} />
      );
    }

    return (
      <>
        {image && (
          <InlineMedia
            title={title}
            publicId={publicId}
            copyright={copyright}
            description={description}
            isMediaClickDisabled={isMediaClickDisabled}
            index={image.index}
            openMediaHandler={() =>
              handleOpenLightBoxImage(image.index, affordances.INLINE_TOPIC)
            }
            mediaType={"image"}
            media={images[image.index]}
            maxIndex={images.length}
          />
        )}

        {algorithm && (
          <AlgorithmBlock
            title={title}
            description={description}
            publicId={publicId}
            isMediaClickDisabled={isMediaClickDisabled}
            index={algorithm.index}
            algorithm={algorithm}
            handleOpenPDF={handleOpenPDF}
            mediaType={"algorithm"}
          />
        )}
      </>
    );
  };

  return {
    processInlineImage,
  };
}
